import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import cx from 'classnames';

import Text from '~/components/Text';
import type { PublicationFormQuestion } from '~/interfaces/form';

interface Props {
  question: PublicationFormQuestion;
}

const LongTextQuestion = ({ question }: Props) => {
  const [charCount, setCharCount] = useState(0);
  const { t } = useTranslation();
  const maxCharacterLimit = question.max_character_limit ? Math.min(1000, question.max_character_limit) : 400;
  const minCharCountColorClass =
    question.min_character_limit && charCount < question.min_character_limit ? 'text-red-500' : 'text-gray-500';
  const maxCharCountColorClass = maxCharacterLimit - charCount < 20 ? 'text-red-500' : 'text-gray-500';

  const isRequired = question.required || question.min_character_limit > 0;

  return (
    <>
      <textarea
        className="wt-body-font h-28 w-full rounded-wt border-2 border-gray-200 text-base font-light text-black placeholder-gray-400 shadow-md focus:border-wt-primary focus:outline-none focus:ring-0 sm:shadow-none"
        maxLength={maxCharacterLimit}
        minLength={question.min_character_limit}
        name={question.id}
        required={isRequired}
        placeholder={t('forms.placeholders.string').toString()}
        onChange={(e) => setCharCount(e.target.value.length)}
      />
      {question.min_character_limit > 0 && (
        <Text size={'sm'} theme="default" type="title">
          <span className={cx(minCharCountColorClass, 'text-xs')}>
            Minumum entry size of {question.min_character_limit} characters
          </span>
        </Text>
      )}
      <Text size={'sm'} theme="default" type="title">
        <span className="inline-block">
          <span className={cx(minCharCountColorClass, maxCharCountColorClass, 'text-xs')}>
            Characters remaining: {maxCharacterLimit - charCount}
          </span>
        </span>
      </Text>
    </>
  );
};

export default LongTextQuestion;
